import { useQuery, useMutation, useQueryClient } from 'react-query'
import client, { multipartclient, deleteclient } from './api-client';


async function addParcels(parcelsData) {
    const data = await client('parcels/', { body: parcelsData })
    return data
}

export function useAddParcelsMutation(parcelsData) {
    const queryClient = useQueryClient();

    return useMutation((parcelsData) => addParcels(parcelsData));
}

async function convertToGeojson(files) {
    const data = await multipartclient('parcels/convert_to_geojson/', { body: files });
    return data;
}

export function useConverToGeojson(files) {
    const queryClient = useQueryClient();

    return useMutation((files) => convertToGeojson(files));
}

async function applyCSVMappings(csvData) {
    const data = await client('parcels/apply_csv_mappings/', { body: csvData });
    return data;
}

export function useApplyCSVMappings() {
    const queryClient = useQueryClient();

    return useMutation((csvData) => applyCSVMappings(csvData));
}

async function deleteParcel(parcel) {
    const data = await deleteclient(`parcels/${parcel.id}/`);
    return data;
}

export function useDeleteParcel(parcel) {
    const queryClient = useQueryClient();

    return useMutation((parcel) => deleteParcel(parcel));
}